/** @file Screen position of point i of a strided world-point array under a camera. */
import { affine } from '@pose2d/math/affine';
import type { Vec2 } from '@pose2d/math/types';
import type { Camera } from '@pose2d/geometry/types';
import { readNum } from './readNum';

/** Strided world (x, y) pairs: point i is at coords[i * stride + offset] (structurally a PointSet). */
interface StridedPoints {
  coords: ArrayLike<number>;
  stride: number;
  offset: number;
}

/** Writes the screen pixel of point i into out and returns it. */
export function projectPoint(points: StridedPoints, i: number, camera: Camera, out: Vec2): Vec2 {
  const k = i * points.stride + points.offset;
  return affine.apply(camera.worldToPixel, readNum(points.coords, k), readNum(points.coords, k + 1), out);
}
